import store from '../store';
import { useToast } from 'vue-toastification';
import { onErrorCaptured } from 'vue';
const toast = useToast();

class ErrorService {
    handle(error) {
        console.log('ErrorService.handle called with:', error);
        
        if (error.response) {
            // Server responded with error status
            if (error.response.data && error.response.data.code) {
                toast.error(`${error.response.data.message}\nCode: ${error.response.data.code}`);
            } else if (error.response.status >= 400 && error.response.status < 500) {
                // Client error (4xx)
                const message = error.response.data?.message || 'Bad request. Please check your input.';
                toast.error(message);
            } else if (error.response.status >= 500) {
                // Server error (5xx)
                toast.error('Your request cannot be performed at this time. Please try again after a while.');
            }
        } else if (error.request) {
            // Request was made but no response received
            console.log('Network error - no response received:', error.request);
            toast.error('Network error. Please check your connection and try again.');
        } else {
            // Something else happened
            console.log('Unexpected error:', error);
            // Only show error toast for actual errors, not for successful operations
            if (error.message && !error.message.includes('success')) {
                toast.error('Your request cannot be performed at this time. Please try again after a while.');
            }
        }
    }
}
export default new ErrorService();